module.exports = __webpack_public_path__ + "img/key_milestones.d65477d1.jpg";